import React, { FC, Fragment } from 'react';
import { PropertyBox, PropertyLabel } from 'components/property-settings/property-shared-styles';
import { NumberOfUnitSettingsOption } from 'models/order-input/action-order';
import { Box } from '@mui/system';
import NumberOnlyTextField2 from 'components/number-only-text-field/number-only-text-field-2';
import { RequiredAsterisk } from 'components/ui/required-asteriks';

type NumberOfUnitProps = {
    onChange: (value: number, header: string, actionId: string) => void;
    options: NumberOfUnitSettingsOption[];
    numberOfUnitsValues: {
        header: string;
        numberOfUnits: number;
        actionId: string;
    }[];
};

const NumberOfUnit: FC<NumberOfUnitProps> = ({ onChange, options, numberOfUnitsValues }) => {
    return (
        <PropertyBox>
            {options.map((option, idx) => {
                const value =
                    numberOfUnitsValues?.find((item) => item.actionId === option.actionId)?.numberOfUnits || 0;
                return (
                    <Fragment key={option.header}>
                        <Box mb={idx !== options.length - 1 ? 1 : 0}>
                            <Box display="flex">
                                <PropertyLabel variant="h5" margin={0}>
                                    {option.header}
                                </PropertyLabel>
                                {option.mandatory && <RequiredAsterisk />}
                            </Box>
                            <Box mt={-1.5}>
                                <NumberOnlyTextField2
                                    value={value}
                                    required={option.mandatory}
                                    hasDecimal={!option.isInteger}
                                    showStepper={option.isInteger}
                                    sx={{
                                        marginTop: 1,
                                        '& .MuiInputBase-root': {
                                            height: 32,
                                            fontSize: '12px',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '12px',
                                        },
                                    }}
                                    onValueChange={(value) => onChange(value, option.header, option.actionId || '')}
                                />
                            </Box>
                        </Box>
                    </Fragment>
                );
            })}
        </PropertyBox>
    );
};

export default NumberOfUnit;
